import React, { useState, useEffect, useMemo } from 'react';
import * as AnalyticsActions from '../../redux/analytics/actions';
import Spinner from 'react-spinkit';
import ClientFunnelTable from '../../components/ClientFunnelTable';
import { useDispatch, useSelector } from 'react-redux';
import { fetchClientFunnelRequested } from '../../store/analytics/actions';

const ClientFunnelPage = () => {
  const dispatch = useDispatch();
  const {
    isEventsLoading: loading,
    events: funnel,
    error
  } = useSelector(state => state.analytics);

  const columns = useMemo(() => ([
    {
      title: 'Событие',
      field: 'name',
    },
    {
      title: 'Пользователи до 7 дней',
      field: 'count7',
    },
    {
      title: 'Пользователи до 30 дней',
      field: 'count30',
    },
    {
      title: 'Пользователи до 90 дней',
      field: 'count90',
    },
  ]), []);

  useEffect(() => {
    dispatch(fetchClientFunnelRequested());
  }, []);

  return (
    <div style={{ width: '100%' }}>
      {
        loading &&
        <div>
          <Spinner name="circle" className="spinner" fadeIn="quarter" color="#3897dc"/>
          <div className="overlay">
          </div>
        </div>
      }
      <div>
        <h3>Воронка клиентов</h3>
      </div>
      <br/>
      {
        error &&
        <div className="form-group">
          <div className="alert alert-danger">
            <strong>Ошибка!</strong> {error}
          </div>
        </div>
      }
      <ClientFunnelTable columns={columns} data={funnel}/>
    </div>
  );
};

export default ClientFunnelPage;



// WEBPACK FOOTER //
// ./src/pages/ClientFunnelPage/index.jsx